import { Grid3X3, Rows, TableProperties } from "lucide-react";
import { ConversationViewMode } from "@/types/conversation";

interface ConversationViewToggleProps {
  value: ConversationViewMode;
  onChange: (mode: ConversationViewMode) => void;
}

const OPTIONS: { mode: ConversationViewMode; label: string; Icon: typeof Grid3X3 }[] = [
  { mode: "table", label: "Table", Icon: TableProperties },
  { mode: "rows", label: "Rows", Icon: Rows },
  { mode: "cards", label: "Cards", Icon: Grid3X3 },
];

export function ConversationViewToggle({ value, onChange }: ConversationViewToggleProps) {
  return (
    <div className="p-[2px] rounded-lg bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8]">
      <div className="flex rounded-[10px] bg-white">
        {OPTIONS.map(({ mode, label, Icon }, idx) => {
          const active = value === mode;
          const isFirst = idx === 0;
          const isLast = idx === OPTIONS.length - 1;
          return (
            <button
              key={mode}
              type="button"
              onClick={() => onChange(mode)}
              className={`px-3 py-2 transition-colors flex items-center gap-2 ${
                active
                  ? "bg-gray-100 text-gray-900 font-medium"
                  : "text-gray-600 hover:bg-gray-50"
              } ${isFirst ? "rounded-l-lg" : ""} ${isLast ? "rounded-r-lg" : ""}`}
              title={`${label} view`}
              aria-pressed={active}
            >
              <Icon className="w-4 h-4" />
              <span className="text-sm hidden sm:inline">{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
